import { Box, Button, Card, CardBody, Flex, Grid, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Loading from 'src/components/loading/Loading'
import { useAppDispatch, useAppSelector } from 'src/redux/hooks'
import { allTranslateQuestion, getQuestionsTranslations } from 'src/view-models/Question'
import TranslationForm from './components/TranslationForm'

const QuestionLanguageDetails = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { pathname } = useLocation()
    const id = pathname.split("/")[3]
    const { translations } = useAppSelector((state) => state.question)

    const [isLoadingQuestion, setIsLoadingQuestion] = useState(true)
    const [isGeneratingAll, setIsGeneratingAll] = useState(false)

    useEffect(() => {
        const fetchQuestionTranslations = async () => {
            await getQuestionsTranslations(id, dispatch)
            setIsLoadingQuestion(false)
        }
        fetchQuestionTranslations()
    }, [id])

    const translateAll = async () => {
        setIsGeneratingAll(true)
        const response: any = await allTranslateQuestion(id, dispatch)
        if (response.status === true) {
        } else {
            return null
        }
        setIsGeneratingAll(false)
    }

    const goToCreateLanguage = () => {
        navigate("/admin/languages/new")
    }

    if (isLoadingQuestion) {
        return <Loading />
    }

    if(!isLoadingQuestion && translations?.question_to !== "patient"){
        navigate("/admin/questions")
    }

    return (
        <Box px={4} py={2} rounded={4}>
            {translations && translations?.data?.length > 0 ? (
                <>
                    <Flex my={4} flexDirection={{ base: 'column', md: 'row' }} alignItems={{ base: 'flex-start', md: 'center' }} justifyContent='space-between' gap={4} >
                        <Box>
                            {/* <Text color='#4E5D78' fontWeight={700} fontSize={30} >{question?.question}</Text>
          <Text color='#4E5D78'>Sur cette page, vous pouvez gérer tous les aspects concernant les langue de <span className='font-bold' >{question?.question}</span></Text> */}
                        </Box>
                        <Button isDisabled={isGeneratingAll} colorScheme='blue' onClick={translateAll} >Traduire le tout</Button>
                    </Flex>
                    <Grid templateColumns={{ base: 'repeat(1,1fr)', lg: translations?.length === 1 ? 'repeat(1,1fr)' : 'repeat(2,1fr)' }} gap={4} sx={{ mb: 10 }}>
                        {translations && translations?.data?.length > 0 && translations?.data?.map((t: any, index: number) => (
                            <Card sx={{ width: "100%" }} key={index}>
                                <CardBody>
                                    <TranslationForm data={t} isGeneratingAll={isGeneratingAll} />
                                </CardBody>
                            </Card>
                        ))}
                    </Grid>
                </>
            ) : (
                <Flex flexDirection={"column"} sx={{alignItems:"center",mt:20,gap:4}}>
                    <Text>Il n'y a pas de langues pour l'instant</Text>
                    <Button  onClick={goToCreateLanguage}>Ajouter une nouvelle langue</Button>
                </Flex>
            )}
        </Box>
    )
}

export default QuestionLanguageDetails